import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import cx from "classnames";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import InProessCreateApplication from "./InProcessCreateApplication";
const useStyles = makeStyles();

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const InProcessCreateApplicationModal = ({
  showModal,
  closeModal,
  requestDetails,
  GetData,
  loanApplicationId,
  seletedBranchCode,
}) => {
  const classes = useStyles();

  const handleClose = () => {
    closeModal();
  };

  return (
    <div className={classes.container}>
      <Dialog
        classes={{
          root: classes.center,
        }}
        maxWidth="md"
        open={showModal}
        // fullScreen={true}
        
        disableEscapeKeyDown
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        {/* <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={cx(classes.modalHeader)}
                >
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                    <div className={cx(classes.modalTitle, classes.loginModalTitle)}>
                        <span className={(classes.titleContent, classes.floatLeft)}>
                            Otp
                        </span>
                    </div>
                </DialogTitle> */}

        <DialogContent
          id="classic-modal-slide-description"
          className={cx(classes.modalBody, classes.loginMaxWidth)}
          justifyContent="center"
        >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <InProessCreateApplication
                closeModal={closeModal}
                loanApplicationId={loanApplicationId}
                GetData={GetData}
                seletedBranchCode={seletedBranchCode}
                // requestDetails={requestDetails}
                // loanApplicationId={loanApplicationId}
              />
            </GridItem>
          </GridContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
};

InProcessCreateApplicationModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  GetData: PropTypes.func,
  requestDetails: PropTypes.object,
  loanApplicationId: PropTypes.object,
};

export default InProcessCreateApplicationModal;
